import {ReadNewsItemsService} from "app/news/service/read-items/ReadNewsItemsService";
import {Observable, Subject} from "rxjs";
import {NewsItemId, NewsItemIds} from "app/news/types/NewsItemId";

export class ReadNewsItemsStore {

    public static readonly id = "readNewsItemsStore";

    private readonly reads$ = new Subject<NewsItemId>();
    private readonly readItems$: Observable<NewsItemIds>;

    /** @ngInject */
    public constructor(private readonly readNewsItemsService: ReadNewsItemsService) {
        this.readItems$ = this.buildReadItems();
        this.watchReads();
    }

    private buildReadItems(): Observable<NewsItemIds> {
        return Observable.of(true)
                         .flatMap(() => this.retrieveReadItems())
                         .flatMap((read) => this.watchChanges(read))
                         .publishReplay(1)
                         .refCount();
    }

    private retrieveReadItems(): Observable<NewsItemIds> {
        return Observable.fromPromise(this.readNewsItemsService.readItems())
                         .catch((err) => Observable.of([]));
    }

    private watchChanges(initial: NewsItemIds): Observable<NewsItemIds> {
        return this.reads$
                   .scan((acc, next) => [next].concat(acc), initial)
                   .startWith(initial);
    }

    private watchReads() {
        this.reads$.subscribe((read) => {
            try {
                this.readNewsItemsService.readItem(read);
            } catch (e) {
                console.error(e);
            }
        });
    }

    public get readItems(): Observable<NewsItemIds> {
        return this.readItems$;
    }

    public markRead(id: NewsItemId) {
        this.reads$.next(id);
    }
}
